export default {
  addButtonText: 'Add',
  home: 'Home',
  work: 'Work',
  custom: 'Custom',
};
